module.exports = __webpack_public_path__ + "static/media/icono_rfc.939cca80.svg";